import { footerContainerStyles } from "@insite/content-library/Widgets/Footer/FooterContainer";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// To avoid a widget override, the names of the grid items might not be descriptive of what content is contained within them.

// For subscription block
footerContainerStyles.logoGridItem = {
    width: 12,
    css: css`
    background-color: ${getColor("primary.main")}`,
};

footerContainerStyles.logoWrapper = {
    css: css`
    width: 100%;
    `,
};

footerContainerStyles.linkList1GridItem = {
    width: 0,
};

footerContainerStyles.linkList2GridItem = {
    width: 0,
};

footerContainerStyles.linkList3GridItem = {
    width: 0,
};

footerContainerStyles.linkList4GridItem = {
    width: 0,
};

footerContainerStyles.subscribeGridItem = {
    width: 0,
};

footerContainerStyles.richContentGridItem = {
    width: 12,
    css: css`
    background-color: ${getColor("secondary.main")}`,
}

footerContainerStyles.widgetGridContainer = {
    css: css`
        margin: 0 auto;
        max-width: 100% !important;
        width: 100%;
    `,
    offsetCss: css`
    margin: 0 !important;
    width: 100% !important;`,
};

footerContainerStyles.socialLinksGridItem = {
    width: 0,
};

footerContainerStyles.siteMapLinksGridItem = {
    width: 0,
};
